// Home.jsx

import React, { useEffect, useMemo } from 'react';

// Context
import { useUser } from 'context/UserContext';
import { useWorkspace } from 'context/WorkspaceContext';

// Routing
import { useNavigate } from 'react-router-dom';

// CSS
import './Home.css';

// Components
import Section from 'components/section/Section';

/**
 * Home
 * 
 * @returns {ReactNode} - Home component.
 */
const Home = () => {

  // ----- CONTEXT ----- //

  // User Context
  const { user } = useUser();

  // Workspace Context
  const { activeWorkspace } = useWorkspace();

  // Routing
  const navigate = useNavigate();

  const activeWorkspaceKey = typeof activeWorkspace?.key === 'string'
    ? activeWorkspace.key.trim()
    : '';

  const pinnedDashboardKey = useMemo(() => {
    if (!activeWorkspaceKey) return '';

    const pinnedMap = user?.data_profile?.pinnedDashboardByWorkspace;
    if (!pinnedMap || typeof pinnedMap !== 'object') return '';

    const pinnedKey = pinnedMap[activeWorkspaceKey];
    return typeof pinnedKey === 'string' ? pinnedKey.trim() : '';
  }, [activeWorkspaceKey, user?.data_profile?.pinnedDashboardByWorkspace]);

  useEffect(() => {
    if (!pinnedDashboardKey) return;
    navigate(`/dashboard/${pinnedDashboardKey}`, { replace: true });
  }, [navigate, pinnedDashboardKey]);

  // ----- RENDER ----- //

  return (

    <Section>

      <div className="home-container">

      </div>

    </Section>

  );
};

export default Home;
